import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../utils/analytics';

const ADMIN_EMAIL = 'admin@nogi46.me';

const PLANS = [
  {
    id: 'bmc-basic',
    icon: 'bi-cup-hot-fill',
    iconColor: '#FFDD00',
    iconBg: '#000',
    titleKey: 'plans.bmc.title',
    descKey: 'plans.bmc.description',
    iosTag: false,
    buttonKey: 'goSubscribe',
    buttonVariant: 'dark',
    url: 'https://buymeacoffee.com/easonyen',
  },
  {
    id: 'bmc-ios',
    icon: 'bi-cup-hot-fill',
    iconColor: '#FFDD00',
    iconBg: '#000',
    titleKey: 'plans.bmcIos.title',
    descKey: 'plans.bmcIos.description',
    iosTag: true,
    buttonKey: 'goSubscribe',
    buttonVariant: 'dark',
    url: 'https://buymeacoffee.com/easonyen',
  },
  {
    id: 'paypal-basic',
    icon: 'bi-paypal',
    iconColor: '#003087',
    iconBg: '#e8eef8',
    titleKey: 'plans.paypalBasic.title',
    descKey: 'plans.paypalBasic.description',
    iosTag: false,
    buttonKey: 'goSubscribe',
    buttonVariant: 'primary',
    url: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-76793734YS3628305NGNQBHA',
  },
  {
    id: 'paypal-ios',
    icon: 'bi-paypal',
    iconColor: '#003087',
    iconBg: '#e8eef8',
    titleKey: 'plans.paypalIos.title',
    descKey: 'plans.paypalIos.description',
    iosTag: true,
    buttonKey: 'goSubscribe',
    buttonVariant: 'primary',
    url: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6XC3976965618941PNI7MFXY',
  },
];

const PaymentPage = () => {
  const { t } = useTranslation('payment');

  useEffect(() => {
    logEvent('payment_view');
  }, []);

  document.title = t('title');

  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="py-5 px-3 w-100" style={{ maxWidth: '1100px' }}>

        {/* 標題 */}
        <div className="text-center mb-5">
          <i className="bi bi-credit-card" style={{ fontSize: '2.5rem', color: '#0d6efd' }}></i>
          <h2 className="fw-bold mt-3 mb-2">{t('title')}</h2>
          <p className="text-muted">{t('subtitle')}</p>
        </div>

        {/* 方案卡片 */}
        <div className="d-flex flex-column flex-md-row gap-4 justify-content-center align-items-center align-items-md-stretch">
          {PLANS.map((plan) => (
            <div
              key={plan.id}
              style={{
                flex: '1 1 260px',
                width: '100%',
                maxWidth: '300px',
                margin: '0 auto',
                background: '#fff',
                borderRadius: '16px',
                border: '1px solid #e9ecef',
                boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* 頂部圖示區 */}
              <div
                style={{
                  background: plan.iconBg,
                  padding: '28px 0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '16px 16px 0 0',
                }}
              >
                <i className={`bi ${plan.icon}`} style={{ fontSize: '2.8rem', color: plan.iconColor }}></i>
              </div>

              {/* 內容區 */}
              <div className="p-4 d-flex flex-column" style={{ flex: 1 }}>
                <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                  <h5 className="fw-bold mb-0">{t(plan.titleKey)}</h5>
                  {plan.iosTag && (
                    <span
                      style={{
                        background: '#1c1c1e',
                        color: '#fff',
                        fontSize: '0.7rem',
                        padding: '2px 10px',
                        borderRadius: '20px',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <i className="bi bi-apple me-1"></i>iOS
                    </span>
                  )}
                </div>
                <p className="text-muted small mb-4">{t(plan.descKey)}</p>
                <a
                  href={plan.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`btn btn-${plan.buttonVariant} w-100 mt-auto`}
                  style={{ borderRadius: '10px', padding: '10px' }}
                >
                  {t(plan.buttonKey)}
                  <i className="bi bi-arrow-up-right ms-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* 備註 */}
        <p className="text-muted text-center mt-5 small">
          {t('note')}
          <br />
          {t('contactEmail')}
          <a href={`mailto:${ADMIN_EMAIL}`} className="text-muted">{ADMIN_EMAIL}</a>
        </p>

      </div>
    </div>
  );
};

export default PaymentPage;
